import {Component, inject, input, model, OnInit, signal} from "@angular/core";
import {SearchableColumn} from "@models";
import {AdministrationTableService} from "../administration-table.service";
import {explicitEffect} from "ngxtension/explicit-effect";

@Component({
	selector: "sim-administration-table-simple-search",
	templateUrl: "./administration-table-simple-search.component.html",
	styleUrl: "./administration-table-simple-search.component.scss",
	standalone: false,
})
export class AdministrationTableSimpleSearchComponent implements OnInit {
	searchableColumns = input.required<SearchableColumn[]>();

	isSearchFieldVisible = signal(false);
	searchColumn = model<string>();

	protected stateService = inject(AdministrationTableService);

	ngOnInit(): void {
		this.searchColumn.set(this.searchableColumns()[0].value);
	}

	private _clearSearchTermEffect = explicitEffect([this.searchColumn], () => {
		const searchTerm = this._getSearchTerm();
		if (!searchTerm) {
			return;
		}

		this.setSearchTerm("");
	});

	protected toggleFilterField() {
		const searchTerm = this._getSearchTerm();
		this.isSearchFieldVisible.update((value) => {
			if (value && searchTerm) {
				this.setSearchTerm("");
			}

			return !value;
		});
	}

	protected setSearchTerm(searchTerm: string) {
		const searchColumn = this.searchColumn();
		if (!searchColumn) {
			return;
		}

		this.stateService.setSearchFilter([
			{
				searchColumn,
				searchTerms: [searchTerm],
			},
		]);
	}

	private _getSearchTerm() {
		const searchTerms = this.stateService.searchFilters()?.[0]?.searchTerms;
		return searchTerms?.[0] ?? "";
	}
}
